import { memo, useEffect, useState } from 'react';
import { cardSrc } from './cardUtils';

/**
 * Live card reveal, admin: the face-down card DISAPPEARS, then the face shows
 * (reference admin, user 2026-10-18). Not the player site's flip — the admin
 * reference is different. The blink lasts CARD_BLINK_MS (index.css
 * .casino-card-blink) — keep the two in step.
 */
export const CARD_BLINK_MS = 150;

/**
 * A card that MOUNTS already face-up (strips that only render dealt cards)
 * blinks too — but not while a table is first filling in, or every card on
 * screen would blink on load. useCasinoGame calls markCardBlinkBaseline() when
 * a table opens; mounts within this window show the face directly.
 */
const MOUNT_GRACE_MS = 1500;
let baselineAt = typeof performance !== 'undefined' ? performance.now() : 0;
export function markCardBlinkBaseline() {
  baselineAt = performance.now();
}

const isHidden = (code) => !code || code === '1' || code === '0';

const CardImg = memo(function CardImg({ code, className = '', ...rest }) {
  const [prevCode, setPrevCode] = useState(code);
  const [blink, setBlink] = useState(
    () => !isHidden(code) && performance.now() - baselineAt > MOUNT_GRACE_MS
  );

  // Decide during render, so the face never paints for a frame before the blink.
  if (code !== prevCode) {
    setPrevCode(code);
    setBlink(isHidden(prevCode) && !isHidden(code));
  }

  // Timer, not animationend: a collapsed strip (display:none) never fires it.
  useEffect(() => {
    if (!blink) return undefined;
    const t = setTimeout(() => setBlink(false), CARD_BLINK_MS);
    return () => clearTimeout(t);
  }, [blink]);

  const cls = [className, blink ? 'casino-card-blink' : ''].filter(Boolean).join(' ');
  return (
    <img
      src={blink ? cardSrc('1') : cardSrc(code)}
      alt={code || ''}
      {...rest}
      className={cls || undefined}
    />
  );
});

export default CardImg;
